import useTranslation from "../../hooks/useTranslation";
import { DemographicGroupWithDetails } from "../../types/workplaceCulture";
import { Paper } from "../ui/Paper/Paper";
import { Typography } from "../ui/Typography/Typography";
import { ReportCustomQuestionDemographicCard } from "./ReportCustomQuestionDemographicCard/ReportCustomQuestionDemographicCard";
import { useCustomDemographicScores } from "./useCustomDemographicScores";
import "./ReportCustomQuestion.scss";

interface ReportCustomQuestionProps {
  customDemographicGroups: DemographicGroupWithDetails[];
  dispatchToken: string;
}

export const ReportCustomQuestion = ({
  customDemographicGroups,
  dispatchToken,
}: ReportCustomQuestionProps) => {
  const { t } = useTranslation("reportPage");
  const { scores, chapterScores, isLoading } = useCustomDemographicScores(
    customDemographicGroups,
    dispatchToken
  );

  return (
    <div className="ReportCustomQuestion">
      <Typography
        tagVariant="h2"
        desktop="h2"
        className="ReportCustomQuestion__title"
        color="darkerStoneBlue"
      >
        {t("customQuestion.title")}
      </Typography>

      <Paper shadow>
        <div className="ReportCustomQuestion__container">
          <div className="ReportCustomQuestion__content">
            <Typography desktop="body2" color="secondary">
              {t("customQuestion.description")}
            </Typography>
          </div>

          {customDemographicGroups.length === 0 ? (
            <div className="ReportCustomQuestion__noData">
              <Typography
                desktop="body1"
                fontStyle="italic"
                color="darkerStoneBlue"
              >
                {t("customQuestion.noData")}
              </Typography>
            </div>
          ) : (
            <div className="ReportCustomQuestion__groups">
              {customDemographicGroups.map((group) => (
                <div
                  key={group.id}
                  className="ReportCustomQuestion__groups__group"
                >
                  <Typography
                    tagVariant="h3"
                    desktop="h3"
                    className="ReportCustomQuestion__groups__group__title"
                    color="darkerStoneBlue"
                  >
                    {group.label}
                  </Typography>
                  <div className="ReportCustomQuestion__groups__group__cards">
                    {group.demographics.map((demographic) => (
                      <ReportCustomQuestionDemographicCard
                        key={demographic.id}
                        demographic={demographic}
                        score={scores[demographic.id] || 0}
                        chapterScores={chapterScores[demographic.id] || []}
                        isLoading={isLoading}
                      />
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </Paper>
    </div>
  );
};
